import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { WorkflowListPage } from 'pages/workflows/pages'
import { WorkflowLayout } from 'pages/workflows/layout/WorkflowLayout'
import { WorkflowsAccessLayout } from 'pages/workflows/layout/WorkflowsAccessLayout'

export const WorkflowsRouter = observer(() => (
  <RoutesWithNotFound>
    <Route element={<WorkflowsAccessLayout />}>
      <Route element={<WorkflowLayout />}>
        <Route index element={<WorkflowListPage />} />
      </Route>
    </Route>
  </RoutesWithNotFound>
))
